import NextImage from "next/image";
import React from "react";
import { FilterNameType } from "@/types/vault-object-filter-types";
import useVaultFilterStore from "@/stores/zustand/vault/useVaultFilterStore";

interface UploadFilterItemProps {
  name: FilterNameType;
  onSelect: (name: FilterNameType) => void;
}

export const VaultObjectFilterItem = ({
  name,
  onSelect,
}: UploadFilterItemProps) => {
  const currentFilter = useVaultFilterStore((state) => state.currentFilter);

  const selected = name === currentFilter.name;

  return (
    <div
      className="cursor-pointer relative flex justify-center items-center w-20 h-10 active:scale-95 transition-all"
      onClick={() => onSelect(name)}
    >
      <NextImage
        src={`/assets/images/vault-object-filter/${name}.webp`}
        width={0}
        height={0}
        sizes={"100vw"}
        alt={"thumbnail"}
        priority
        className="w-20 h-10 z-10"
        style={{
          boxSizing: "content-box",
          objectFit: "cover",
          borderRadius: `${selected ? 6 : 4}px`,
          border: "1px solid var(--border-tertiary)",
          boxShadow: selected ? "0 0 6px 4px var(--accent-8)" : undefined,
        }}
        draggable={false}
      />
    </div>
  );
};
